/**
 * Merkt sich den Anzeigenamen auf diesem Gerät.
 *
 * Die Anmeldeseite begrüßt mit Namen („Sveni ist wieder da."), hat aber keine
 * Sitzung und kann deshalb nichts abfragen. Ohne diesen Speicher gäbe es keine
 * Begrüßung.
 *
 * Er wird an jeder Stelle geschrieben, an der der Name bekannt wird: bei jeder
 * Art von Anmeldung und beim Auflösen des Anzeigenamens. Bis 20.09.2026 hing
 * er allein an Handlungen auf genau diesem Gerät — Passwort-Anmeldung, Profil
 * speichern, Profilschritt. Eine OAuth-Anmeldung schrieb ihn nie, und ein auf
 * einem anderen Gerät gewählter Spitzname kam nie an: Im Browser stand „Sven
 * Kaiser", in der Cloud längst „Sveni"
 * (`.claude/tasks/web-wiedererkennung.md`).
 *
 * `localStorage` kann werfen (privater Modus, gesperrte Website-Daten). Ein
 * fehlender Begrüßungsname ist kein Grund, eine Anmeldung scheitern zu lassen.
 */
export const LAST_FULL_NAME_KEY = 'lastFullName'

export function rememberDisplayName(name: string | null | undefined): void {
  const trimmed = name?.trim()
  if (!trimmed) return

  try {
    localStorage.setItem(LAST_FULL_NAME_KEY, trimmed)
  } catch {
    /* non-fatal */
  }
}
